module.exports = __webpack_public_path__ + "img/tpkz-img.abc3ba1b.jpg";